import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router } from '@angular/router';
import { IdentityService } from './identity.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate, CanActivateChild{
  constructor(private router: Router, private identityService: IdentityService){}

  async canActivate(): Promise<boolean>{
    console.log("access reserved to admins")
    //const user = await firebase.auth().onAuthStateChanged();
    const user = await this.identityService.getIdentity();
    const token = await user.getIdTokenResult();
    if (!token.claims.admin){
      this.router.navigate(['/m']);
      return false;
    }
    return true;
  }

  canActivateChild(): Promise<boolean>{
    return this.canActivate();
  }
}
